export const TERMS_OF_SERVICE_LINK =
  'https://app.termly.io/policy-viewer/policy.html?policyUUID=b3d4ba0d-30c8-497d-ac68-4c9c5c679b9f#ppno';
export const PRIVACY_POLICY_LINK =
  'https://app.termly.io/policy-viewer/policy.html?policyUUID=7c056265-dbe3-4c9f-ae64-ee780b520180';
